Ext.define('SA.view.manageproject.ManageProject', {
    alias: 'widget.manage-project',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-manage-project',
    selected: 'locations',

    initComponent() {
        this.items = [
            {
                xtype: 'component',
                cls: 'sa-manage-project-welcome-wrap',

                html: [
                    '<div class="sa-manage-project-title">Welcome to SimplyAnalytics</div>',
                    '<div class="sa-manage-project-welcome-message">',
                        'Please add some locations, data variables, and businesses to your project using the three tabs ',
                        'on the left. After you add at least one location and one variable we will automatically create ',
                        'some maps and reports for you. If you have any questions or issues please click on the support ',
                        'button at the top of the page.',
                    '</div>'
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-manage-project-header',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-manage-project-title',
                        html: 'Manage your project'
                    }, {
                        xtype: 'component',
                        cls: 'sa-manage-project-warning',
                        itemId: 'warning',

                        tpl: [
                            '<svg class="sa-manage-project-warning-svg"><use href="#sa-icon-warning"></use></svg>',
                            '<div>{message}</div>'
                        ]
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-manage-project-body-wrap',

                items: [
                    {
                        xtype: 'simple-container',
                        cls: 'sa-manage-project-lists-ct',

                        items: [
                            {
                                xtype: 'simple-container',
                                cls: 'sa-manage-project-panel',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-manage-project-panel-header',
                                        html: 'Locations, Data, Businesses'
                                    }, {
                                        xtype: 'component',
                                        cls: 'sa-manage-project-type-btn-wrapper',

                                        html: [
                                            '<a class="sa-manage-project-type-btn" data-type="locations">',
                                                '<svg class="sa-manage-project-type-btn-icon"><use href="#sa-icon-locations"></use></svg>',
                                                'Locations',
                                            '</a>',
                                            '<a class="sa-manage-project-type-btn" data-type="data">',
                                                '<svg class="sa-manage-project-type-btn-icon"><use href="#sa-icon-data"></use></svg>',
                                                'Data',
                                            '</a>',
                                            '<a class="sa-manage-project-type-btn" data-type="businesses">',
                                                '<svg class="sa-manage-project-type-btn-icon"><use href="#sa-icon-businesses"></use></svg>',
                                                'Businesses',
                                            '</a>'
                                        ]
                                    }, {
                                        xtype: 'component',
                                        cls: 'sa-manage-project-list',
                                        itemId: 'locationsList',

                                        tpl: [
                                            '<tpl if="!length">',
                                                '<span class="sa-manage-project-list-empty">',
                                                    'There are no locations currently associated with this project',
                                                '</span>',
                                            '</tpl>',
                                            '<tpl for=".">',
                                                '<div data-id="{id}" class="sa-manage-project-list-item">',
                                                    '<tpl if="type">',
                                                        '<span class="sa-manage-project-list-item-icon-wrap">',
                                                            '<svg class="sa-manage-project-list-item-icon">',
                                                                '<tpl if="type === \'combination\'">',
                                                                    '<use href="#sa-icon-combination-location"></use>',
                                                                '<tpl elseif="type === \'radius\'">',
                                                                    '<use href="#sa-icon-radius-location"></use>',
                                                                '</tpl>',
                                                            '</svg>',
                                                        '</span>',
                                                    '</tpl>',
                                                    '<div class="sa-manage-project-list-item-name">{name}<tpl if="unit"> ({unit})</tpl></div>',
                                                        '<a class="sa-manage-project-list-item-button sa-manage-project-list-item-remove">',
                                                            '<svg class="sa-manage-project-list-item-button-icon"><use href="#sa-icon-close"></use></svg>',
                                                        '</a>',
                                                '</div>',
                                            '</tpl>'
                                        ]
                                    }, {
                                        xtype: 'component',
                                        cls: 'sa-manage-project-list',
                                        itemId: 'dataList',

                                        tpl: [
                                            '<tpl if="!length">',
                                                '<span class="sa-manage-project-list-empty">',
                                                    'There are no data variables currently associated with this project',
                                                '</span>',
                                            '</tpl>',
                                            '<tpl for=".">',
                                                '<div data-id="{attribute}" class="sa-manage-project-list-item">',
                                                    '<div class="sa-manage-project-list-item-name">{name:htmlEncode}, {year}</div>',
                                                    '<a class="sa-manage-project-list-item-button sa-manage-project-list-item-remove">',
                                                        '<svg class="sa-manage-project-list-item-button-icon"><use href="#sa-icon-close"></use></svg>',
                                                    '</a>',
                                                '</div>',
                                            '</tpl>'
                                        ]
                                    }, {
                                        xtype: 'component',
                                        cls: 'sa-manage-project-list',
                                        itemId: 'businessesList',

                                        tpl: [
                                            '<tpl if="!length">',
                                                '<span class="sa-manage-project-list-empty">',
                                                    'There are no business searches currently associated with this project',
                                                '</span>',
                                            '</tpl>',
                                            '<tpl for=".">',
                                                '<div data-id="{id}" class="sa-manage-project-list-item">',
                                                    '<div class="sa-manage-project-list-item-name">{name:htmlEncode}</div>',
                                                    '<a class="sa-manage-project-list-item-button sa-manage-project-list-item-remove">',
                                                        '<svg class="sa-manage-project-list-item-button-icon"><use href="#sa-icon-close"></use></svg>',
                                                    '</a>',
                                                '</div>',
                                            '</tpl>'
                                        ]
                                    }
                                ]
                            }, {
                                xtype: 'simple-container',
                                cls: 'sa-manage-project-panel',

                                items: [
                                    {
                                        xtype: 'component',
                                        cls: 'sa-manage-project-panel-header',
                                        html: 'Manage Views'
                                    }, {
                                        xtype: 'manage-project-views-list',
                                        project: this.projectView
                                    }
                                ]
                            }
                        ]
                    }, {
                        xtype: 'sa-button',
                        cls: 'sa-manage-project-delete-button',
                        icon: 'sa-icon-close',
                        text: 'Delete Project',

                        handler: () => {
                            Ext.widget({
                                xtype: 'delete-project-popup',
                                project: this.projectView
                            });
                        }
                    }
                ]
            }
        ];

        this.callParent();

        this.lists = {
            businesses: this.down('#businessesList'),
            data: this.down('#dataList'),
            locations: this.down('#locationsList')
        };

        this.viewsList = this.down('manage-project-views-list');
        this.warning = this.down('#warning');
    },

    afterRender() {
        this.callParent();

        this.refresh();

        this.mon(this.projectView, {
            buffer: 10,
            scope: this,

            'change:attribute': this.refresh,
            'change:businessSearch': this.refresh,
            'change:location': this.refresh,
            'change:view': this.refresh,
            'change:view:attribute': this.refresh,
            'change:view:businessSearch': this.refresh,
            'change:view:location': this.refresh,
            'change:view:name': this.refresh
        });

        this.mon(SA.data.LocationAliases, {
            buffer: 10,
            scope: this,

            'change': this.refresh
        });

        this.mon(SA.data.BusinessSearches, {
            buffer: 10,
            scope: this,

            'change:name': this.refresh
        });
    },

    initEvents() {
        var el = this.el,
            lists = this.lists;

        this.callParent();

        el.on({
            delegate: '.sa-manage-project-type-btn',

            click: (ev, target) => {
                this.selected = target.getAttribute('data-type');

                this.refresh();
            },

            mouseout(ev, target) {
                Ext.fly(target).removeCls('sa-manage-project-type-btn-hover');
            },

            mouseover(ev, target) {
                Ext.fly(target).addCls('sa-manage-project-type-btn-hover');
            }
        });

        el.on({
            delegate: '.sa-manage-project-list-item-button',

            mousedown(ev, target) {
                Ext.fly(target).addCls('sa-manage-project-list-item-button-active');

                Ext.getDoc().on({
                    single: true,

                    mouseup() {
                        Ext.fly(target).removeCls('sa-manage-project-list-item-button-active');
                    }
                });
            },

            mouseout(ev, target) {
                Ext.fly(target).removeCls('sa-manage-project-list-item-button-hover');
            },

            mouseover(ev, target) {
                Ext.fly(target).addCls('sa-manage-project-list-item-button-hover');
            }
        });

        lists.locations.el.on({
            delegate: '.sa-manage-project-list-item-remove',

            click: ev => {
                var location = ev.getTarget('[data-id]').getAttribute('data-id'),
                    project = this.projectView;

                project.removeLocation(location);
                project.save();
            }
        });

        lists.data.el.on({
            delegate: '.sa-manage-project-list-item-remove',

            click: ev => {
                var attribute = ev.getTarget('[data-id]').getAttribute('data-id'),
                    project = this.projectView;

                project.removeAttribute(attribute);
                project.save();
            }
        });

        lists.businesses.el.on({
            delegate: '.sa-manage-project-list-item-remove',

            click: ev => {
                var search = +ev.getTarget('[data-id]').getAttribute('data-id'),
                    project = this.projectView;

                project.removeBusinessSearch(search);
                project.save();
            }
        });
    },

    refresh() {
        var project = this.projectView,
            lists = this.lists,
            locationsList = lists.locations,
            dataList = lists.data,
            businessesList = lists.businesses,
            locations = SA.data.LocationsCache.get(project.getLocations()),
            attributes = SA.data.AttributesCache.get(project.getAttributes()),
            businesses = SA.data.BusinessSearches.get(project.getBusinessSearches()),
            hasData = attributes.length || businesses.length,
            buttons = this.el.query('.sa-manage-project-type-btn'),
            warningCmp = this.warning,
            warningMsg = '';

        Ext.suspendLayouts();

        this.removeCls('sa-manage-project-welcome-visible');

        if (!project.getViews().length) {
            if (locations.length) {
                if (!hasData) {
                    warningMsg = 'Add data to your project';
                }
            }
            else {
                if (hasData) {
                    warningMsg = 'Add locations to your project';
                }
                else {
                    this.addCls('sa-manage-project-welcome-visible');
                }
            }
        }

        warningCmp.setVisible(!!warningMsg);
        warningCmp.update({message: warningMsg});

        locationsList.update(locations.map(location => {
            var unit;

            if (!location.type) {
                unit = SA.data.GeographicUnits.get(location.geographicUnit).singularName;
            }

            return {
                id: SA.data.LocationsCache.toLocationSeries(location),
                name: Ext.util.Format.locationRenderer(location),
                type: location.type,
                unit
            };
        }));

        dataList.update(attributes);

        businessesList.update(businesses);

        this.viewsList.refresh();

        for (let list in lists) {
            lists[list].setVisible(this.selected === list);
        }

        buttons.forEach(btn => {
            Ext.fly(btn).ifCls(btn.getAttribute('data-type') === this.selected, 'sa-manage-project-type-btn-selected');
        });

        Ext.resumeLayouts(true);
    }
});
